import type { IconData } from '@stacksjs/iconify-core'

export const flickrCircle: IconData = {
  "body": "<g fill=\"currentColor\"><circle cx=\"7.364\" cy=\"10.379\" r=\"2.364\"/><circle cx=\"12.628\" cy=\"10.379\" r=\"2.364\"/><path d=\"M10 18.494a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2c-5.523 0-10-4.478-10-10s4.477-10 10-10s10 4.477 10 10s-4.477 10-10 10\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default flickrCircle
